module.exports = __webpack_public_path__ + "static/img/14000282.b933bb08.png";